import React from 'react';
import PropTypes from 'prop-types';

import 'whatwg-fetch';

import { ERROR_USER_ALERT, INFO_USER_ALERT } from '../../SharedComponents/UserMessaging';
import ProductComponents from './Features/ProductComponents';
import { mapPropsToInitialState } from './mapPropsToInitialState';
import miniCartClient from '../../util/miniCartClient';
import { makeCatalystFetchPostInit } from '../../util/fetchUtility';

import '../product-shared.css';

let messageId = 0;
const createUserMessage = ({ text, type }) => ({ id: messageId++, text, type });

class ProductApp extends React.Component {
    constructor(props) {
        super(props);
        this.state = mapPropsToInitialState(props);

        this.onAddToCart = this.onAddToCart.bind(this);
        this.addUserMessage = this.addUserMessage.bind(this);
        this.onDismissMessage = this.onDismissMessage.bind(this);
    }

    onAddToCart({ variation, quantity, cartName }) {
        if (cartName === "Default" && (!variation.InventoryDetails || variation.InventoryDetails.TotalInStock < quantity)) {
            let message = quantity > 0 ? `Only ${variation.InventoryDetails.TotalInStock} in stock.` : 'Out of stock.'
            this.addUserMessage(createUserMessage({
                text: message,
                type: ERROR_USER_ALERT
            }));

            return;
        }

        const submitMethod = 'POST';
        fetch(
            this.state.addToCartEndpoint,
            makeCatalystFetchPostInit({ code: variation.Code, quantity, cartName })
            ).then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    if (typeof console !== 'undefined' && console.log) {
                        console.error(
                            `Error sending ${submitMethod} to ${this.state.addToCartEndpoint}: (${response.statusCode}) ${response
                                .statusText}`);
                    }

                    return { hasError: true, message: `An error occurred procesing your request: ${response.statusText}` };
                }
            })
            .then(({ hasError, message }) => {
                if (hasError) {
                    this.addUserMessage(createUserMessage({
                        text: `We're sorry, but we could not add this item to your cart: ${message}${
                            message && message[message.length - 1] === '.' ? '' : '.'
                            } Please reload the page and retry, or contact customer service.`,
                        type: ERROR_USER_ALERT
                    }));
                    return;
                }

                this.addUserMessage(createUserMessage({
                    text: `Item with sku ${variation.Code} was added`,
                    type: INFO_USER_ALERT
                }));

                miniCartClient.updateCart(cartName);
            });
    }

    addUserMessage(message) {
        const existingMessages = this.state.userMessages;
        this.setState({ userMessages: existingMessages ? existingMessages.concat(message) : [message] });
    }

    onDismissMessage(id) {
        this.setState({
            userMessages: this.state.userMessages
                ? this.state.userMessages.filter((message) => message.Id !== id)
                : []
        });
    }

    render() {
        const defaultAssetsGroup = this.props.AssetsGroups.find(gp => gp.GroupName === 'default'),
            isColorPicker = this.props.PageLayout === 'colorpicker' || this.props.PageLayout === 'colordropdown';
        return (
            <ProductComponents
                assets={defaultAssetsGroup && defaultAssetsGroup.Assets}
                blogs={this.props.RelatedBlogs}
                documentWarranties={this.props.DocumentWarranties}
                dealerDocuments={this.props.DealerDocuments}
                gallery={this.props.ProjectGallery}
                isColorPicker={isColorPicker}
                messages={this.state.userMessages}
                onAddToCart={this.onAddToCart}
                onDismissMessage={this.onDismissMessage}
                traits={this.state.traits}
                variations={this.state.variations}
                videos={this.props.VideoGallery}
                trait1Selected={this.state.trait1Selected}
                trait2Selected={this.state.trait2Selected}
                customerType={this.state.customerType}
                siteName={this.state.siteName}
                wishlistModel={this.state.wishlistModel}
            />
        );
    }
}

ProductApp.propTypes = {
    DealerDocuments: PropTypes.array,
    DocumentWarranties: PropTypes.object,
    Name: PropTypes.string.isRequired,
    PriceViewModel: PropTypes.object,
    ProjectGallery: PropTypes.object,
    RelatedBlogs: PropTypes.object,
    ShowAddToQuoteButton: PropTypes.bool,
    ShowBuyButton: PropTypes.bool,
    Variations: PropTypes.array.isRequired,
    VideoGallery: PropTypes.object,
    WishlistModel: PropTypes.object
};

export default ProductApp;